import {
  Field as HeadlessField,
  type FieldProps as HeadlessFieldProps,
} from "@headlessui/react";
import { classNames } from "../../utils/classNames";

export type FieldProps = HeadlessFieldProps;

export function Field({ className, ...props }: HeadlessFieldProps) {
  return (
    <HeadlessField
      className={classNames(
        "[&>[data-slot=label]+[data-slot=control]]:mt-2",
        "[&>[data-slot=label]+[data-slot=description]]:mt-0",
        "[&>[data-slot=description]+[data-slot=control]]:mt-2",
        "[&>[data-slot=control]+[data-slot=description]]:mt-2",
        "[&>[data-slot=control]+[data-slot=feedback]]:mt-2",
        "[&>[data-slot=label]]:font-medium",
        className,
      )}
      {...props}
    />
  );
}
